import {
	getNumber,
	getString,
} from "../../../../../utils/mappersUtils/object";
import { isObject } from "../../../../../utils/mappersUtils/guards";

export const mapMessageTemplateUseCase = (useCase) => {
	if (!isObject(useCase)) {
        return null;
    }

    return {
        id: getNumber(useCase, "id"),
        useCase: getNumber(useCase, "useCase", 0),
        description: getString(useCase, "description", ""),
        messageType: getNumber(useCase, "messageType", 1),
        objectType: getNumber(useCase, "objectType", 1),
    };
};

export const mapMessageTemplateUseCases = (useCases) => {
    if (!Array.isArray(useCases)) {
        return [];
    }

    return useCases
        .map((useCase) => mapMessageTemplateUseCase(useCase))
        .filter((useCase) => useCase !== null);
}

